export const DesignCategories = [
    {
        id: 0,
        title: 'All',
        image: "/assets/images/designs/all.webp",
    },
    {
        id: 1,
        title: 'Modern',
        image: "/assets/images/designs/modern.jpg",
    },
    {
        id: 2,
        title: 'Box Type',
        image: "/assets/images/designs/boxtype.jpeg",
    },
    {
        id: 3,
        title: 'Classical',
        image: "/assets/images/designs/classical.jpeg",
    },
    {
        id: 4,
        title: 'Neo Classical',
        image: "/assets/images/designs/neoclassical.jpeg",
    },
    {
        id: 5,
        title: 'Traditional',
        image: "/assets/images/designs/traditional.jpg",
    },
    {
        id: 6,
        title: 'Commercial',
        image: "/assets/images/designs/commercial.webp",
    },
    {
        id: 7,
        title: 'Appartment',
        image: "/assets/images/designs/appartment.jpg",
    },
    {
        id: 8,
        title: 'Bungalow',
        image: "/assets/images/designs/appartment.jpg",
    },
];
export const DesignCategory = [
    {
        label: 'Modern',
        value: 'Modern',
    },
    {
        label: 'Box Type',
        value: 'Box Type',
    },
    {
        label: 'Classical',
        value: 'Classical',
    },
    {
        label: 'Neo Classical',
        value: 'Neo Classical',
    },
    {
        label: 'Traditional',
        value: 'Traditional',
    },
    {
        label: 'Commercial',
        value: 'Commercial',
    },
    {
        label: 'Appartment',
        value: 'Appartment',
    },
    {
        label: 'Bungalow',
        value: 'Bungalow',
    },
];